import Sheet from 'react-modal-sheet';
import close from '../assets/images/icons/icon-close.svg';
import '../scss/daily-prize-description-modal.scss';

interface Props {
  isActive: boolean;
  setIsActive: (isActive: boolean) => void;
}

export const PrizeResultsModal: React.FC<Props> = ({ isActive, setIsActive }) => {
  const onClose = () => {
    setIsActive(false);
  };

  return (
    <Sheet isOpen={isActive} onClose={onClose} className="daily-prize-description-modal">
      <Sheet.Container>
        <Sheet.Header>
          <div className="d-flex justify-content-end pt-3 pe-3 pb-3">
            <img className="cursor-pointer" width={25} height={25} src={close} alt="close modal" onClick={onClose} />
          </div>
        </Sheet.Header>
        <Sheet.Content>
          <div className="content">
            <h2 className="fz-20 mb-2">PROGLAŠENJE DOBITNIKA NAGRADE NA YETTEL SHOPPINGU</h2>
            <p className="text">
              Yettel Shopping kuponijada je završena i proglašeno je 45 dobitnika nagrada, korisnika Yettel mreže, sa
              najvećim brojem sačuvanih kupona i dva iskorišćena kupona, u periodu od 1.3.2024. do 31.3.2024. U slučaju
              da je više korisnika imalo isti broj sačuvanih kupona, prvenstvo ima korisnik sa dužim pretplatničkim
              stažom u Yettel mreži. Korisnici će biti kontaktirani u najkraćem mogućem roku kako bi dostavili dokaze o
              iskorišćenim kuponima (dva fiskalna računa). Nakon provere, korisnici će biti ponovo kontaktirani kako bi
              dogovorili preuzimanje nagrade.
            </p>
            <p className="text">
              U svrhu zaštite privatnosti podataka naših korisnika, njihovi lični podaci neće biti prikazani.
            </p>
            <p className="text">Rangiranje dobitnika nagrade:</p>

            <ol className="mb-3" style={{ listStyle: 'auto', paddingLeft: 35, lineHeight: 1.4 }}>
              <li>mesto: 38169626XXX, 774 kupona, Nagrada: iPhone 14 256GB po ceni od 1 RSD</li>
              <li>mesto: 38163215XXX, 774 kupona, Nagrada: iPhone 14 256GB po ceni od 1 RSD</li>
              <li>mesto: 38162200XXX, 774 kupona, Nagrada: iPhone 14 256GB po ceni od 1 RSD</li>
              <li>mesto: 381637100XXX, 771 kupon, Nagrada: iPhone 14 256GB po ceni od 1 RSD</li>
              <li>mesto: 381641396XXX, 771 kupon, Nagrada: iPhone 14 256GB po ceni od 1 RSD</li>
              <li>mesto: 381637835XXX, 770 kupona, Nagrada: ComputerLand - XBOX Series S 512GB</li>
              <li>mesto: 381637869XXX, 770 kupona, Nagrada: ComputerLand - XBOX Series S 512GB</li>
              <li>
                mesto: 381691140XXX, 769 kupona, Nagrada: BC Group - Laptop Toshiba Dynabook Satellite Pro C40-G-109
              </li>
              <li>mesto: 381692709XXX, 769 kupona, Nagrada: BC Group - TV TESLA 32E635BSH Smart</li>
              <li>mesto: 38162476XXX, 769 kupona, Nagrada: Zepter - MyIon Z pro sterilizator</li>
              <li>mesto: 381611477XXX, 768 kupona, Nagrada: Vulkan Izdavaštvo - Komplet knjiga Ivo Andrić</li>
              <li>mesto: 38162234XXX, 767 kupona, Nagrada: Vulkan Izdavaštvo - Komplet knjiga Ivo Andrić</li>
              <li>mesto: 38163634XXX, 766 kupona, Nagrada: Vulkan Izdavaštvo - Komplet knjiga Ivo Andrić</li>
              <li>mesto: 381606783XXX, 765 kupona, Nagrada: Vulkan Izdavaštvo - Komplet knjiga Ivo Andrić</li>
              <li>mesto: 381631286XXX, 765 kupona, Nagrada: Vulkan Izdavaštvo - Komplet knjiga Ivo Andrić</li>
              <li>mesto: 38169651XXX, 765 kupona, Nagrada: Balkan Fun - Putovanje za 1.Maj u Paraliju</li>
              <li>
                mesto: 38163692XXX, 764 kupona, Nagrada: Hotel Agape Zlatibor – Vaučer za smeštaj 2 noći za dve osobe
              </li>
              <li>mesto: 38163492XXX, 764 kupona, Nagrada: PC Centar – Xiaomi Buds 3T Pro slušalice</li>
              <li>mesto: 38169692XXX, 763 kupona, Nagrada: Peak Sport – Dres Nikole Jokića</li>
              <li>mesto: 38163362XXX, 762 kupona, Nagrada: Under Armour – Project Rock ranac</li>
              <li>mesto: 38163517XXX, 761 kupon, Nagrada: Remiks.com – Vaučer u vrednosti od 10.000 RSD</li>
              <li>
                mesto: 381638658XXX, 761 kupon, Nagrada: Planeta Sport – Vaučer u vrednosti od 10.000 RSD za kupovinu
                proizvoda brendova Rang i Wintro
              </li>
              <li>
                mesto: 381691811XXX, 761 kupon, Nagrada: Planeta Sport – Vaučer u vrednosti od 10.000 RSD za kupovinu
                proizvoda brendova Rang i Wintro
              </li>
              <li>mesto: 381648812XXX, 761 kupon, Nagrada: Legend - Vaučer u vrednosti od 5000 RSD</li>
              <li>mesto: 38163573XXX, 761 kupon, Nagrada: Legend - Vaučer u vrednosti od 5000 RSD</li>
              <li>mesto: 381637342XXX, 761 kupon, Nagrada: Legend - Vaučer u vrednosti od 5000 RSD</li>
              <li>mesto: 381693135XXX, 759 kupona, Nagrada: Wolt – Vaučer u vrednosti od 3000 RSD</li>
              <li>mesto: 38162605XXX, 758 kupona, Nagrada: Wolt – Vaučer u vrednosti od 3000 RSD</li>
              <li>mesto: 381695548XXX, 758 kupona, Nagrada: Wolt – Vaučer u vrednosti od 3000 RSD</li>
              <li>mesto: 381641122XXX, 758 kupona, Nagrada: Wolt – Vaučer u vrednosti od 3000 RSD</li>
              <li>mesto: 38162330XXX, 757 kupona, Nagrada: Wolt – Vaučer u vrednosti od 3000 RSD</li>
              <li>mesto: 38162316XXX, 757 kupona, Nagrada: Crafter – Vaučer u vrednosti od 3000 RSD</li>
              <li>mesto: 381640115XXX, 756 kupona, Nagrada: Crafter – Vaučer u vrednosti od 3000 RSD</li>
              <li>mesto: 381638845XXX, 755 kupona, Nagrada: Crafter – Vaučer u vrednosti od 3000 RSD</li>
              <li>mesto: 381631577XXX, 753 kupona, Nagrada: Crafter – Vaučer u vrednosti od 3000 RSD</li>
              <li>mesto: 381621843XXX, 753 kupona, Nagrada: Mr.D – Vaučer u vrednosti od 2500 RSD</li>
              <li>mesto: 381692720XXX, 752 kupona, Nagrada: Mr.D – Vaučer u vrednosti od 2500 RSD</li>
              <li>mesto: 38169705XXX, 752 kupona, Nagrada: Mr.D – Vaučer u vrednosti od 2500 RSD</li>
              <li>mesto: 38163212XXX, 750 kupona, Nagrada: Mr.D – Vaučer u vrednosti od 2500 RSD</li>
              <li>mesto: 381637145XXX, 750 kupona, Nagrada: Mr.D – Vaučer u vrednosti od 2500 RSD</li>
              <li>mesto: 381611981XXX, 750 kupona, Nagrada: Mr.D – Vaučer u vrednosti od 2500 RSD</li>
              <li>mesto: 381637245XXX, 749 kupona, Nagrada: Mr.D – Vaučer u vrednosti od 2500 RSD</li>
              <li>mesto: 381691489XXX, 749 kupona, Nagrada: Mr.D – Vaučer u vrednosti od 2500 RSD</li>
              <li>mesto: 381628344XXX, 749 kupona, Nagrada: Mr.D – Vaučer u vrednosti od 2500 RSD</li>
              <li>mesto: 381692212XXX, 748 kupona, Nagrada: Mr.D – Vaučer u vrednosti od 2500 RSD</li>
            </ol>

            <p className="text">
              Svima korisnicima se zahvaljujemo na učešću i pozivamo vas da nastavite da pratite Yettel Shopping, kao i
              da učestvujete u narednim promocijama.
            </p>
          </div>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop onTap={onClose} />
    </Sheet>
  );
};
